var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMobile = function SvgMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 51
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.99
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00A6FF",
    d: "M50 25.09c0 13.808-11.193 25-25 25s-25-11.192-25-25 11.193-25 25-25 25 11.193 25 25"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#F5FAFD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M20.966 17.453v-3.255a2.714 2.714 0 0 1 2.723-2.706h14.303a2.714 2.714 0 0 1 2.722 2.706v8.84a2.714 2.714 0 0 1-2.722 2.707h-1.499v2.664l-1.486-1.041"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#F5FAFD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M28.982 19.237H14.156c-2.69 0-4.87 2.167-4.87 4.84v8.05c0 2.674 2.18 4.84 4.87 4.84h1.45l.066 3.166 5.556-3.166h7.754c2.69 0 4.871-2.166 4.871-4.84v-8.05c0-2.673-2.18-4.84-4.87-4.84zm-13.343 6.508h10.918m-10.918 4.909h6.385"
  }))));
};
export default SvgMobile;